import { Controller } from 'stimulus'

export default class extends Controller {

  connect() {
    // Setup
    this.cbInstance = this._loadCbInstance()
    this.locale     = this.data.get('locale')
    this.csrf       = document.querySelector('meta[name="csrf-token"]').getAttribute('content')

    // Auto-open trial if needed
    if (this.data.get('trial') === 'true')
      this.getProPlusTrial()
  }

  // Get Free Trial
  getProPlusTrial() {
    this.cbInstance.openCheckout({
      hostedPage: () => this._fetchChargeBee('pro-plus-with-trial'),
    })
  }

  // Buy CORE
  getCore() {
    this.cbInstance.openCheckout({
      hostedPage: () => this._fetchChargeBee('core'),
    })
  }

  // Buy Maintenance
  getMaintenance() {
    this.cbInstance.openCheckout({
      hostedPage: () => this._fetchChargeBee('maintenance'),
    })
  }

  // Buy Advanced
  getAdvanced() {
    this.cbInstance.openCheckout({
      hostedPage: () => this._fetchChargeBee('advanced'),
    })
  }

  // Buy Intelligence
  getIntelligence() {
    this.cbInstance.openCheckout({
      hostedPage: () => this._fetchChargeBee('intelligence'),
    })
  }

  _fetchChargeBee(plan) {
    return fetch('/api/charge_bee/generate_checkout_new_session', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.csrf
      },
      body: JSON.stringify({
          plan_id: plan,
          locale: this.locale
      })
    }).then(checkout => checkout.json())
  }


  _loadCbInstance() {
    if (this.data.get('env') === 'production')
      return window.Chargebee.init({ site: 'yuman' })
    else
      return window.Chargebee.init({ site: 'yuman-test' })
  }
}
